<template>
    <div class="gengduo">
        <p>基础信息</p>
        <div class="title">
            <span>基础资料</span>
            <p></p>
        </div>
        <ul>
            <li><span>昵称：</span>{{arr.space_name}}</li>
            <li><span>姓名：</span>{{arr.space_name}}</li>
            <li v-if="arr.sex==='0'"><span>性别：</span>{{arr.sex==='0'?'保密':''}}</li>
            <li v-else><span>性别：</span>{{arr.sex==='1'?'男':'女'}}</li>
            <li><span>生日：</span>{{arr.birthday}}</li>
            <li><span>地区：</span>暂无{{arr.mycountry}}</li>
            <li><span>就读：</span>{{arr.shcool_name}}</li>
            <li><span>个性签名：</span>{{arr.space_brief}}</li>
        </ul>
    </div>
</template>

<script>
import URL from "../../api/index"; 
export default {
    data(){ 
        return{
            arr:[],
            UserInfo:'',
            getSpaceinfo:'',
            iteminfo:'',
            spaceid:''
        }
    },
    mounted(){
        this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
        this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
        this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
        if(this.iteminfo) {
            this.spaceid = this.iteminfo.space_id
        } else{
            this.spaceid = this.getSpaceinfo.space_id
        }
        var that =this
        var getspace_data={
            token:that.UserInfo.token,
            spaceid:that.spaceid,
        }
            // 查询空间
        this.$post(URL.getSpace,getspace_data).then(res=>{
            // console.log(res.result);
            this.arr = res.result
        })
    }
}
</script>

<style lang="less" scoped>
*{
    margin: 0;
    padding: 0;
}
.gengduo{
    width: 877px;
    background-color: #fff;
    padding: 25px;
    p{
        line-height: 66px;
        font-family: MicrosoftYaHei;
        font-size: 18px;
        color: #6e7578;
    }
    .title{
        margin-bottom: 30px;
        position: relative;
        span{
            color: #a7a8a8;
            line-height: 20px;
        }
        p{
            width: 749px;   
            display: inline-block;
            border: 1px solid #e3e3e3;
            position: absolute;
            top: 50%;
            right: -38%;
            transform: translate(-50%,-50%);
        }
    }
    ul{
        li{
            width: 95%;
            color: #a7a8a8;
            line-height: 48px;
            font-size: 14px;
            span{
                width: 70px;
                display: inline-block;
                color: #6e7578;
            }
        }
    }
}
</style>
